import { $_app_server } from '@/_helpers'

export const authorService = {
  authors
}

function authors() {
  return $_app_server.get("public/authors")
    .then(response => {
        return response.data
    })
}